
    import './styles.scoped.css';
    export default {
  "resizable-box": "awsui_resizable-box_cufu9_2ku8x_9",
  "cursor-active": "awsui_cursor-active_cufu9_2ku8x_13",
  "resizable-box-handle": "awsui_resizable-box-handle_cufu9_2ku8x_27",
  "resize-active": "awsui_resize-active_cufu9_2ku8x_36"
};
  